import { combineReducers, Reducer } from 'redux';

import waivers from './waivers';
import users from './users/usersReducer';
import travelers from './travelers/travelerProfileReducer';
import brandingImage from './brandingImage/brandingImageReducer';

import { EntityState, Action } from '../types';

const rootReducer: Reducer<EntityState, Action<any>> = combineReducers({
  waivers,
  users,
  travelers,
  brandingImage,
});

export default rootReducer;
